<div class="menu">
  <!--<span class="menu-heading" style="border:solid 1px yellow; width:500px !important"> Select a Task</span>-->
  <!--<div class="menu-heading" style="width: 90%;float: left;"> Select a Task</div>
    <div *ngIf="isCloseable" class="menu-heading" (click)="closeTaskSelection()" style="width: 3%; float: left; cursor: pointer">X</div>-->
  <span class="menu-heading">{{taskMenuHeading}}</span>
  <span class="close" *ngIf=" this.queueList.length > 0"  (click)="closeTaskSelection()">X</span>
</div>
<ng-container *ngIf="this.queueList.length > 0 || (this.isTM && (this.isAuditor || this.isManager || this.isStaffer)); else elseBlock">
<div class="console">
  <div *ngIf="hdrText !== ''">
    <div class="console-heading">
      {{ hdrText }}
    </div>
    <div class="manager-btns">
      <button class="nav-btn1" *ngIf="btnText !== ''" (click)="goToConsole()">
        <img alt="" class="ico1" src="{{ baseHref }}/assets/images/task_menu/manage_agents.png" />
        <!--<img alt="" class="ico1" />-->
        {{ btnText }}
      </button>

      <button class="nav-btn2" *ngIf="isReporter" (click)="goToDashboard()">
        <img alt="" class="ico1" src="{{ baseHref }}/assets/images/task_menu/reporting_dashboard.png" />
        Reporting Dashboard
        <img alt="" class="ico2" src="{{ baseHref }}/assets/images/task_menu/ext_link.png" alt="" />
      </button>
    </div>
  </div>

  <!--  <div class="accordion" id="accordion-menus">
              <ng-container *ngFor="let item of lists; let i = index">
                  <div class="accordion-item" *ngIf="item.name!='Search'; else search">
                      <h2 class="accordion-header" [id]="'heading'+i">
                          <button class="accordion-button" [ngClass]="{ 'collapsed': i != 0 }" type="button" data-bs-toggle="collapse"
                              [attr.data-bs-target]="'#collapse'+i" [attr.aria-expanded]="i == 0"
                              [attr.aria-controls]="'collapse'+i">
                              <span class="menu-item">{{item.name}} </span> <span
                                  class="count">{{item.totalrecords}}</span>
                          </button>
                      </h2>
                      <div [id]="'collapse'+i" class="accordion-collapse collapse" [ngClass]="{ 'show': i == 0 }"
                          [attr.aria-labelledby]="'heading'+i" data-bs-parent="#accordion-menus">
                          <div class="accordion-body">
                              <div class="tbodyDiv">
                                  <table class="table table-hover table-striped text-center">
                                      <thead class="sticky-top bg-white">
                                          <tr class="table-heading">
                                              <th scope="col">Queue Type</th>
                                              <th scope="col">Name</th>
                                              <th scope="col">Dialer Type</th>
                                              <th scope="col">Records</th>
                                          </tr>
                                      </thead>
                                      <tbody class="table-values">
                                          <tr *ngFor="let it of item.data" (click)="goToQueue(it.id)">
 
                                              <td>{{it.type}}</td>
                                              <td>{{it.name}}</td>
                                              <td>{{it.dialertype}}</td>
                                              <td>{{it.countLabel}}</td>
 
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-container>
 
 
              <ng-template #search>
                  <div class="accordion-item">
                      <h2 class="accordion-header" id="headingThree">
                          <button class="accordion-button1" type="button">
                              <span class="menu-item">Search </span> <span></span>
                          </button>
                      </h2>
                  </div>
              </ng-template>
 
 
          </div>-->

  <div class="accordion" id="accordion-menus">
    <accordion [closeOthers]="true">
      <accordion-group *ngFor="let item of lists; let i = index" #groupVal [isOpen]="item.name === selectedAccordion"
        [ngClass]="{'d-none': item.name === 'Email' && !enableEmailQueue}">
        <button class="btn btn-block justify-content-between d-flex w-100 collapse-btn" accordion-heading type="button">
          <span class="menu-item">
            {{ item.name }}
            <ng-container>
              <img
                alt=""
                class="group-img"
                src="{{ baseHref }}/assets/images/icon-inbound.svg"
                *ngIf="item.name === 'Inbound'"
              />
              <img
                alt=""
                class="group-img"
                src="{{ baseHref }}/assets/images/icon-outbound.svg"
                *ngIf="item.name === 'Outbound'"
              />
              <!-- src="{{ baseHref }}/assets/images/icon-search.svg" -->
              <img
                alt=""
                class="group-img"
                src="{{ baseHref }}/assets/images/task_menu/search.png"
                style="width: 1rem"
                *ngIf="item.name === 'Search'"
              />
              <img
                alt=""
                class="group-img"
                src="{{ baseHref }}/assets/images/icon-video-chat.svg"
                *ngIf="item.name === 'Text/Video Chat'"
              />
              <img
                alt=""
                class="group-img"
                src="{{ baseHref }}/assets/images/icon-email.svg"
                *ngIf="item.name === 'Email'"
              />
            </ng-container>
          </span>

          <span class="count">{{ item.totalrecords }}</span>
          <span class="arrow">
            <img
              alt=""
              class="collapse-expang-img"
              src="{{ baseHref }}/assets/images/icon-collapse-arrow.png"
              *ngIf="groupVal?.isOpen"
            />

            <img
              alt=""
              class="collapse-expang-img"
              src="{{ baseHref }}/assets/images/icon-expand-arrow.png"
              *ngIf="!groupVal?.isOpen"
            />
          </span>
          <!--<span class="badge badge-secondary bg-secondary float-right pull-right">Some HTML
                                          here</span>-->
        </button>
        <!--
                            <button class="accordion-button" [ngClass]="{ 'collapsed': i != 0 }" type="button" data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#collapse'+i" [attr.aria-expanded]="i == 0"
                            [attr.aria-controls]="'collapse'+i">
                            <span class="menu-item">{{item.name}} </span> <span
                                class="count">{{item.totalrecords}}</span>
                        </button>-->

        <div class="tbodyDiv">
          <table class="table table-hover table-striped text-center">
            <thead class="sticky-top bg-white">
              <tr class="table-heading">
                <th scope="col">Queue Type</th>
                <th scope="col">Name</th>
                <th scope="col">Dialer Type</th>
                <th scope="col">Records</th>
              </tr>
            </thead>
            <tbody class="table-values">
              <tr class="hyperlink" *ngFor="let it of item.data" (click)="goToQueue(it)">
                <td>{{ it.type }}</td>
                <td>{{ it.name }}</td>
                <td>{{ it.dialertype }}</td>
                <td>{{ it.countLabel }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </accordion-group>
    </accordion>
  </div>
</div>
</ng-container>

<ng-template #elseBlock>
    <div class="console-container">
      <div class="input-wrapper">
        <div class="row">
          <p class="queueMessage">{{noQueues}}</p>
        </div>
      </div>
      <div class="bottom-line"></div>
      <div class="text-end mt-3">
        <button class="main-btn large" style="margin-left: auto;" (click)="logout()"> <img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-logout.svg" /> Log Out </button>
      </div>
    </div>
</ng-template>
